module.exports = __webpack_public_path__ + "img/sPutH.b2af16fe.svg";